/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stage_Banner_NextInputs */

const en_stage_banner_next = /** @type {(inputs: Stage_Banner_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next Stage`)
};

const pt_br2_stage_banner_next = /** @type {(inputs: Stage_Banner_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próxima Etapa`)
};

/**
* | output |
* | --- |
* | "Next Stage" |
*
* @param {Stage_Banner_NextInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const stage_banner_next = /** @type {((inputs?: Stage_Banner_NextInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stage_Banner_NextInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stage_banner_next(inputs)
	return pt_br2_stage_banner_next(inputs)
});